module.exports = __webpack_public_path__ + "img/android_mask.e214b074.png";